import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';

export default class Information extends Default {
  
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();
  }

  afterShow() {
    super.afterShow();
  }

  beforeHide() {
    super.beforeHide();
  }

  afterHide() {
    super.afterHide();
  }
}

ControllerPage._addPage("info", Information)
